import classnames from "classnames";

import {HeadingProps} from "./Heading.props.ts";

import styles from "./Heading.module.scss";

export const Heading = ({children, className, as}: HeadingProps) => {
  const Component = as;
  return <Component className={classnames(className, styles[as])}>{children}</Component>;
};
